import DashboardIcon from "@mui/icons-material/Dashboard";
import VerticalAlignCenterOutlinedIcon from "@mui/icons-material/VerticalAlignCenterOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import LockPersonOutlinedIcon from "@mui/icons-material/LockPersonOutlined";

const menuItemsMapping = {
  Bottler: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/dashboard",
      title: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: 3,
      path: "/manage-forecast",
      title: "Manage Forecast",
      label: "Manage Forecast",
      icon: <VerticalAlignCenterOutlinedIcon />,
    },
    {
      id: 4,
      path: "/history",
      title: "History",
      label: "History",
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: 5,
      //path: "/metrics",
      path: "/power-bi-reports",
      title: "Metrics",
      label: "Metrics",
      icon: <QueryStatsIcon />,
    },
    {
      id: 6,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
  ],
  CSR: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/dashboard",
      title: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: 3,
      path: "/history",
      title: "History",
      label: "History",
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: 4,
      //path: "/metrics",
      path: "/power-bi-reports",
      title: "Metrics",
      label: "Metrics",
      icon: <QueryStatsIcon />,
    },
    {
      id: 5,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
    {
      id: 6,
      path: "/accessmanagement",
      title: "Access Management",
      label: "Access Management",
      icon: <LockPersonOutlinedIcon />,
    },
  ],
  DemandPlanner: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/dashboard",
      title: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: 3,
      path: "/history",
      title: "History",
      label: "History",
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: 4,
      //path: "/metrics",
      path: "/power-bi-reports",
      title: "Metrics",
      label: "Metrics",
      icon: <QueryStatsIcon />,
    },
    {
      id: 5,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
  ],
  Admin: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/dashboard",
      title: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: 3,
      path: "/manage-forecast",
      title: "Manage Forecast",
      label: "Manage Forecast",
      icon: <VerticalAlignCenterOutlinedIcon />,
    },
    {
      id: 4,
      path: "/history",
      title: "History",
      label: "History",
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: 5,
      //path: "/metrics",
      path: "/power-bi-reports",
      title: "Metrics",
      label: "Metrics",
      icon: <QueryStatsIcon />,
    },
    {
      id: 6,
      path: "/manage-users",
      title: "Manage Users",
      label: "Manage Users",
      icon: <ManageAccountsIcon />,
    },
    {
      id: 7,
      path: "/onboard-bottler",
      title: "Bottler Onboarding",
      label: "Bottler Onboarding",
      icon: <PersonAddOutlinedIcon />,
    },
    {
      id: 8,
      path: "/accessmanagement",
      title: "Access Management",
      label: "Access Management",
      icon: <LockPersonOutlinedIcon />,
    },
    {
      id: 9,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
    {
      id: 10,
      path: "/reports",
      title: "Report",
      label: "Report",
      icon: <SummarizeOutlinedIcon />,
    },
    {
      id: 11,
      path: "/profitcenter",
      title: "Profit Center",
      label: "Profit Center",
      icon: <BusinessCenterIcon />,
    },
    {
      id: 12,
      path: "/mf-dashboard",
      title: "Manage Forecast Dashboard",
      label: "Manage Forecast Dashboard",
      icon: <BusinessCenterIcon />,
    },
    {
      id: 13,
      path: "/mf-history",
      title: "Manage Forecast History",
      label: "Manage Forecast History",
      icon: <BusinessCenterIcon />,
    },
  ],
  SuperUser: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/manage-users",
      title: "Manage Users",
      label: "Manage Users",
      icon: <ManageAccountsIcon />,
    },
    {
      id: 3,
      path: "/onboard-bottler",
      title: "Bottler Onboarding",
      label: "Bottler Onboarding",
      icon: <PersonAddOutlinedIcon />,
    },
    {
      id: 4,
      //path: "/metrics",
      path: "/power-bi-reports",
      title: "Metrics",
      label: "Metrics",
      icon: <QueryStatsIcon />,
    },
    {
      id: 5,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
    {
      id: 6,
      path: "/accessmanagement",
      title: "Access Management",
      label: "Access Management",
      icon: <LockPersonOutlinedIcon />,
    },
    {
      id: 7,
      path: "/reports",
      title: "Report",
      label: "Report",
      icon: <SummarizeOutlinedIcon />,
    },
  ],
  IT: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/dashboard",
      title: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      id: 3,
      path: "/history",
      title: "History",
      label: "History",
      icon: <ScheduleOutlinedIcon />,
    },
    {
      id: 4,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
  ],
  ROLE_ANONYMOUS: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/authorize",
      title: "Authorize",
      label: "Authorize",
      icon: <AnnouncementOutlinedIcon />,
    },
  ],
  MultiPCMaint: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/profitcenter",
      title: "Profit Center",
      label: "Profit Center",
      icon: <BusinessCenterIcon />,
    },
    {
      id: 3,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
  ],
  MultiPCAdmin: [
    // { id: 1, path: "/login", title: "Login", label: "Login" },
    {
      id: 2,
      path: "/profitcenter",
      title: "Profit Center",
      label: "Profit Center",
      icon: <BusinessCenterIcon />,
    },
    {
      id: 3,
      path: "/ticket-summary",
      title: "Ticket Summary",
      label: "Ticket Summary",
      icon: <SummarizeIcon />,
    },
  ],
  // NO_ROLES: [
  //   //   { id: 1, path: "/login", title: "Login", label: "Login" },
  //   {
  //     id: 2,
  //     path: "/accessmanagement",
  //     title: "Access Merge",
  //     label: "Access Merge",
  //     icon: <LockPersonOutlinedIcon />,
  //   },
  // ],
};

const rolePriority = [
  "CSR",
  "Bottler",
  "DemandPlanner",
  "Admin",
  "SuperUser",
  "MultiPCAdmin",
  "MultiPCMaint",
  "IT",
  "ROLE_ANONYMOUS",
  // "NO_ROLES",
];

const getMenuItems = (roleList) => {
  const menuItems = [];

  // Process roles in the order of rolePriority
  rolePriority.forEach((priorityRole) => {
    if (roleList.includes(priorityRole) && menuItemsMapping[priorityRole]) {
      menuItems.push(...menuItemsMapping[priorityRole]);
    }
  });

  // Process any roles in roleList that are not in rolePriority
  roleList.forEach((role) => {
    if (!rolePriority.includes(role) && menuItemsMapping[role]) {
      menuItems.push(...menuItemsMapping[role]);
    }
  });

  // Remove duplicate menu items based on the path, keeping the first occurrence (highest priority)
  return [...new Map(menuItems.map((item) => [item.path, item])).values()];
};

export { menuItemsMapping, getMenuItems, rolePriority };
